module.exports = __webpack_public_path__ + "static/media/pagination-first.9fa08762.svg";